<template>
  <v-form ref="ETABLISSEMENT_IDENTITE" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="ETABLISSEMENT_IDENTITE">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <etablissement-alias v-if="isDisplayed('ALIAS')"
                             ref="ALIAS"
                             :theme="theme"
                             :showMissing="showMissing"
                             v-model:value=alias
                             @status=statusAlias
                             :over-ride-placeholder=placeholderAlias
                             :required="isRequired('ALIAS')"
                             :contextId=etablissement.id
                             :readOnly="readOnly('ALIAS')"
                             :objType=objType
                             :fiche=fiche
                             :sectionName="sectionName">
        </etablissement-alias>
        <etablissement-nom v-if="isDisplayed('NOM')"
                           ref="NOM"
                           :theme="theme"
                           :showMissing="showMissing"
                           v-model:value=nom
                           @status=statusNom
                           :over-ride-placeholder=placeholderNom
                           :required="isRequired('NOM')"
                           :contextId=etablissement.id
                           :readOnly="readOnly('NOM')"
                           :objType=objType
                           :fiche=fiche
                           :sectionName="sectionName">
        </etablissement-nom>
        <etablissement-ville v-if="isDisplayed('VILLE')"
                             ref="VILLE"
                             :theme="theme"
                             :showMissing="showMissing"
                             v-model:value=ville
                             @status=statusVille
                             :over-ride-placeholder=placeholderVille
                             :required="isRequired('VILLE')"
                             :contextId=etablissement.id
                             :readOnly="readOnly('VILLE')"
                             :objType=objType
                             :fiche=fiche
                             :sectionName="sectionName">
        </etablissement-ville>
        <forme-juridique-select v-if="isDisplayed('FORME_JURIDIQUE_ID')"
                                ref="FORME_JURIDIQUE_ID"
                                :theme="theme"
                                :showMissing="showMissing"
                                v-model:value=formeJuridiqueId
                                :moduleId=moduleId
                                libelle="'Forme juridique'"
                                newLabel=''
                                selectText=""
                                @status=statusFormeJuridiqueId
                                :requiredAttributs="requiredAttributs"
                                :autoSelect=true
                                :ressource=ressourceFormeJuridiqueSelect
                                :filters=formeJuridiqueIdFilter
                                :toggleReset=resetFormeJuridiqueId
                                :required="isRequired('FORME_JURIDIQUE_ID')"
                                :contextId=etablissement.id
                                :readOnly="readOnly('FORME_JURIDIQUE_ID')"
                                :objType=objType
                                :fiche=fiche
                                :sectionName="sectionName">
        </forme-juridique-select>
        <etablissement-soumis-tva v-if="isDisplayed('SOUMIS_TVA')"
                                  ref="SOUMIS_TVA"
                                  :theme="theme"
                                  :showMissing="showMissing"
                                  v-model:value=soumisTva
                                  @status=statusSoumisTva
                                  :required="isRequired('SOUMIS_TVA')"
                                  :contextId=etablissement.id
                                  :readOnly="readOnly('SOUMIS_TVA')"
                                  :objType=objType
                                  :fiche=fiche
                                  :sectionName="sectionName">
        </etablissement-soumis-tva>
        <etablissement-siret v-if="isDisplayed('SIRET')"
                             ref="SIRET"
                             :theme="theme"
                             :showMissing="showMissing"
                             v-model:value=siret
                             @status=statusSiret
                             :over-ride-placeholder=placeholderSiret
                             :required="isRequired('SIRET')"
                             :contextId=etablissement.id
                             :readOnly="readOnly('SIRET')"
                             :objType=objType
                             :fiche=fiche
                             :sectionName="sectionName">
        </etablissement-siret>
        <branche-select v-if="isDisplayed('BRANCHE_ID')"
                        ref="BRANCHE_ID"
                        :theme="theme"
                        :showMissing="showMissing"
                        v-model:value=brancheId
                        :moduleId=moduleId
                        libelle="'Branche'"
                        newLabel=''
                        selectText=""
                        @status=statusBrancheId
                        :requiredAttributs="requiredAttributs"
                        :autoSelect=true
                        :ressource=ressourceBrancheSelect
                        :filters=brancheIdFilter
                        :toggleReset=resetBrancheId
                        :required="isRequired('BRANCHE_ID')"
                        :contextId=etablissement.id
                        :readOnly="readOnly('BRANCHE_ID')"
                        :objType=objType
                        :fiche=fiche
                        :sectionName="sectionName">
        </branche-select>
        <convention-branche-list v-if="isDisplayed('CONVENTION_ID')"
                                 ref="CONVENTION_ID"
                                 :theme="theme"
                                 :showMissing="showMissing"
                                 v-model:value=conventionId
                                 :etablissement=etablissement
                                 :moduleId=moduleId
                                 libelle="'Convention'"
                                 newLabel=''
                                 selectText="Sélectionner une convention"
                                 @status=statusConventionId
                                 :requiredAttributs="requiredAttributs"
                                 :autoSelect=true
                                 :ressource=ressourceConventionBrancheList
                                 :filters=conventionIdFilter
                                 :toggleReset=resetConventionId
                                 :required="isRequired('CONVENTION_ID')"
                                 :contextId=etablissement.id
                                 :readOnly="readOnly('CONVENTION_ID')"
                                 :objType=objType
                                 :fiche=fiche
                                 :sectionName="sectionName">
        </convention-branche-list>
        <etablissement-t3252 v-if="isDisplayed('T3252')"
                             ref="T3252"
                             :theme="theme"
                             :showMissing="showMissing"
                             v-model:value=t3252
                             @status=statusT3252
                             :required="isRequired('T3252')"
                             :contextId=etablissement.id
                             :readOnly="readOnly('T3252')"
                             :objType=objType
                             :fiche=fiche
                             :sectionName="sectionName">
        </etablissement-t3252>
        <etablissement-t1790 v-if="isDisplayed('T1790')"
        ref="T1790"
        :theme="theme"
        :showMissing="showMissing"
        v-model:value=t1790
        @status=statusT1790
        :required="isRequired('T1790')"
        :contextId=etablissement.id
        :readOnly="readOnly('T1790')"
        :objType=objType
        :fiche=fiche
        :sectionName="sectionName">
        </etablissement-t1790>
        <tranche-effectif-select v-if="isDisplayed('TRANCHE_EFFECTIF_ID')"
                                 ref="TRANCHE_EFFECTIF_ID"
                                 :theme="theme"
                                 :showMissing="showMissing"
                                 v-model:value=trancheEffectifId
                                 :moduleId=moduleId
                                 libelle="'Tranche effectif'"
                                 newLabel=''
                                 selectText=""
                                 @status=statusTrancheEffectifId
                                 :requiredAttributs="requiredAttributs"
                                 :autoSelect=true
                                 :ressource=ressourceTrancheEffectifSelect
                                 :filters=trancheEffectifIdFilter
                                 :toggleReset=resetTrancheEffectifId
                                 :required="isRequired('TRANCHE_EFFECTIF_ID')"
                                 :contextId=etablissement.id
                                 :readOnly="readOnly('TRANCHE_EFFECTIF_ID')"
                                 :objType=objType
                                 :fiche=fiche
                                 :sectionName="sectionName">
        </tranche-effectif-select>
        <etablissement-date-creation v-if="isDisplayed('DATE_CREATION')"
                                     ref="DATE_CREATION"
                                     :theme="theme"
                                     :showMissing="showMissing"
                                     v-model:value=dateCreation
                                     @status=statusDateCreation
                                     :periods='periodDateCreation'
                                     :required="isRequired('DATE_CREATION')"
                                     :contextId=etablissement.id
                                     :readOnly="readOnly('DATE_CREATION')"
                                     :objType=objType
                                     :fiche=fiche
                                     :sectionName="sectionName">
        </etablissement-date-creation>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudEtablissement from '@/generated/cruds/CrudEtablissement';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudEtablissement,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.ETABLISSEMENT_IDENTITE,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        placeholderAlias: null,
        placeholderNom: null,
        placeholderVille: null,
        placeholderSiret: null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },

      ressourceFormeJuridiqueSelect () { return RessourceGenControl(GenControl.ETABLISSEMENT_IDENTITE_FORME_JURIDIQUE_SELECT); },
      ressourceBrancheSelect () { return RessourceGenControl(GenControl.ETABLISSEMENT_IDENTITE_BRANCHE_SELECT); },
      ressourceConventionBrancheList () { return RessourceGenControl(GenControl.ETABLISSEMENT_IDENTITE_CONVENTION_BRANCHE_LIST); },
      ressourceTrancheEffectifSelect () { return RessourceGenControl(GenControl.ETABLISSEMENT_IDENTITE_TRANCHE_EFFECTIF_SELECT); },

      ressource () { return RessourceGenSection(GenSection.ETABLISSEMENT_IDENTITE); },

      fields (): string[] {
        return ['ALIAS', 'NOM', 'VILLE', 'FORME_JURIDIQUE_ID', 'SOUMIS_TVA', 'SIRET', 'BRANCHE_ID', 'CONVENTION_ID', 'T3252', 'T1790', 'TRANCHE_EFFECTIF_ID', 'DATE_CREATION'];
      },

      extraButtons (): Button[] {
        return [];
      },

      formeJuridiqueIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
      brancheIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
      conventionIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
      trancheEffectifIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editEtablissement.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("ALIAS", false);
          this.readOnlyMap.set("NOM", this.editEtablissement.nom != '');
          this.readOnlyMap.set("VILLE", true);
          this.readOnlyMap.set("FORME_JURIDIQUE_ID", true);
          this.readOnlyMap.set("SOUMIS_TVA", false);
          this.readOnlyMap.set("SIRET", this.editEtablissement.siret != '');
          this.readOnlyMap.set("BRANCHE_ID", true);
          this.readOnlyMap.set("CONVENTION_ID", true);
          this.readOnlyMap.set("T3252", false);
          this.readOnlyMap.set("T1790", false);
          this.readOnlyMap.set("TRANCHE_EFFECTIF_ID", true);
          this.readOnlyMap.set("DATE_CREATION", true);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("ALIAS", this.requiredMissing(requiredAttributs, "ALIAS") || !!this.fiche);
          this.displayMap.set("NOM", true);
          this.displayMap.set("VILLE", this.requiredMissing(requiredAttributs, "VILLE") || !!this.fiche);
          this.displayMap.set("FORME_JURIDIQUE_ID", this.requiredMissing(requiredAttributs, "FORME_JURIDIQUE_ID") || !!this.fiche);
          this.displayMap.set("SOUMIS_TVA", this.requiredMissing(requiredAttributs, "SOUMIS_TVA") || !!this.fiche);
          this.displayMap.set("SIRET", true);
          this.displayMap.set("BRANCHE_ID", this.requiredMissing(requiredAttributs, "BRANCHE_ID") || !!this.fiche);
          this.displayMap.set("CONVENTION_ID", this.requiredMissing(requiredAttributs, "CONVENTION_ID") || !!this.fiche);
          this.displayMap.set("T3252", this.requiredMissing(requiredAttributs, "T3252") || !!this.fiche);
          this.displayMap.set("T1790", this.requiredMissing(requiredAttributs, "T1790") || !!this.fiche);
          this.displayMap.set("TRANCHE_EFFECTIF_ID", this.requiredMissing(requiredAttributs, "TRANCHE_EFFECTIF_ID") || !!this.fiche);
          this.displayMap.set("DATE_CREATION", this.requiredMissing(requiredAttributs, "DATE_CREATION") || !!this.fiche);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("ALIAS", this.requiredMissing(requiredAttributs, "ALIAS") || !this.fiche);
          this.requiredMap.set("NOM", true);
          this.requiredMap.set("VILLE", this.requiredMissing(requiredAttributs, "VILLE") || !this.fiche);
          this.requiredMap.set("FORME_JURIDIQUE_ID", this.requiredMissing(requiredAttributs, "FORME_JURIDIQUE_ID") || !this.fiche);
          this.requiredMap.set("SOUMIS_TVA", this.requiredMissing(requiredAttributs, "SOUMIS_TVA") || !this.fiche);
          this.requiredMap.set("SIRET", true);
          this.requiredMap.set("BRANCHE_ID", this.requiredMissing(requiredAttributs, "BRANCHE_ID") || !this.fiche);
          this.requiredMap.set("CONVENTION_ID", this.requiredMissing(requiredAttributs, "CONVENTION_ID") || !this.fiche);
          this.requiredMap.set("T3252", this.requiredMissing(requiredAttributs, "T3252") || !this.fiche);
          this.requiredMap.set("T1790", this.requiredMissing(requiredAttributs, "T1790") || !this.fiche);
          this.requiredMap.set("TRANCHE_EFFECTIF_ID", this.requiredMissing(requiredAttributs, "TRANCHE_EFFECTIF_ID") || !this.fiche);
          this.requiredMap.set("DATE_CREATION", this.requiredMissing(requiredAttributs, "DATE_CREATION") || !this.fiche);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoIdentite' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
